import React from 'react';
import { eventTypes } from 'appConstants';

/**
 * This hook conditionally sets the default event type in the Create Event modal.
 * The default event type is Event. This sets the default to be Meeting.
 * Currently implemented for one customer, but it is behind a flag if other
 * customers would like to adopt it.
 */
export const useEventTypeDefaultSelector = (setType, calendarEventsListReorder) =>
  React.useEffect(
    () => {
      if (calendarEventsListReorder) {
        // if the customer would like the default event type to be 'Meeting'
        setType(eventTypes.PRIVATE);
      }
      // unable to add 'setType' to the dependency array as it would cause an infinite re-render
    },
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [calendarEventsListReorder],
  );
